import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'ggApp/shared/containers/tooltip';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import { Container, Icon, TextWrap, Discount, ToolTipText } from './styled';

class GroverCareBadge extends React.PureComponent {
    render() {
        const { className, withFreeService, tooltipText } = this.props;
        return (
            <Container className={className}>
                <Icon />
                <TextWrap>
                    {withFreeService && (
                        <Discount>
                            <Translator tk="SERVICE_TEXT_INCLUSIVE" />
                        </Discount>
                    )}
                    <Tooltip tooltipTK={tooltipText}>
                        <ToolTipText>
                            <Translator tk="SERVICE_TEXT_GROVER_CARE" />
                        </ToolTipText>
                    </Tooltip>
                </TextWrap>
            </Container>
        );
    }
}

GroverCareBadge.propTypes = {
    className: PropTypes.string,
    withFreeService: PropTypes.bool,
    tooltipText: PropTypes.string,
};

GroverCareBadge.defaultProps = {
    className: '',
    withFreeService: false,
    tooltipText: '',
};

export default GroverCareBadge;
